export function parseJwtPayload(token) {
  if (!token || typeof token !== "string") return null;
  const raw = token.startsWith("Bearer ") ? token.slice(7) : token;
  const parts = raw.split(".");
  if (parts.length < 2) return null;
  try {
    const base64 = parts[1].replaceAll("-", "+").replaceAll("_", "/");
    const json = globalThis.atob(base64);
    return JSON.parse(json);
  } catch {
    return null;
  }
}

export function getAuthContextFromToken(token) {
  const payload = parseJwtPayload(token);
  if (!payload) {
    return { role: null, loginId: null };
  }
  const role = typeof payload.role === "string" ? payload.role.trim() : null;
  const loginIdRaw = payload["login-id"] ?? payload.info?.loginId;
  const loginId = loginIdRaw == null ? null : Number(loginIdRaw);
  return {
    role,
    loginId: Number.isFinite(loginId) ? loginId : null,
  };
}
